import { render } from "./DeletePasskeyDialog.vue?vue&type=template&id=55bb5d59"
import script from "./DeletePasskeyDialog.vue?vue&type=script&lang=js"
export * from "./DeletePasskeyDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__